import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import {
  getApiBaseUrl,
  AuthActionTypeList,
  AuthWorkerResponseType,
} from "./auth/config";

import AuthWorker from "./auth/AuthWorker";
import worker from "./auth/auth-worker";

new AuthWorker(worker);

// Need to set up this and send over to the worker from here as workers don't have access to the window scope
let apiGatewayUrl = getApiBaseUrl();

// Here we're subscribing to the AUTH_CHANNEL channel to receive messages from the auth.worker
const channel = new BroadcastChannel("AUTH_CHANNEL");
//
//Timeout to make sure the worker is ready before sending the message
setTimeout(() => {
  channel.postMessage({
    action: AuthActionTypeList.LOGIN,
    apiGatewayUrl,
  });
}, 1000);

// This is our main message listener. It'll subscribe to some messages fired up from the worker and perform the appropriate actions
channel.onmessage = (ev: MessageEvent<AuthWorkerResponseType>) => {
  switch (ev.data.action) {
    case AuthActionTypeList.LOGGED_IN:
      renderApp();
      break;
    case AuthActionTypeList.NO_DATA:
      console.log("no data");
      attemptRedirect();
      break;
  }
};

const attemptRedirect = () => {
  try {
    window.location.href = `${process.env.REACT_APP_API_URL}/auth/login?returnUrl=${window.location.href}`;
  } catch (error) {
    ReactDOM.render(
      <React.StrictMode>
        <h1>Authentication failed</h1>
        <p>Error while redirecting to authenticate</p>
      </React.StrictMode>,
      document.getElementById("root")
    );
  }
};

const renderApp = () => {
  ReactDOM.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
    document.getElementById("root")
  );
};
